import NewInspection from "@/views/agro_exporter/quality_control/container/NewInspection.vue";
import EditInspection from "@/views/agro_exporter/quality_control/container/EditInspection.vue";
import ListProcesses from "@/views/agro_exporter/quality_control/container/ListProcesses.vue";
import ListContainers from "@/views/agro_exporter/quality_control/container/ListContainers.vue";
import ListTemplates from "@/views/agro_exporter/quality_control/container/ListTemplates.vue";
import ContainersInspectGraphs from "@/views/agro_exporter/quality_control/container/ContainersInspectGraphs.vue";
import ListQualityInspects from "@/views/agro_exporter/quality_control/container/ListQualityInspects.vue";
import ShowQualityInspect from "@/views/agro_exporter/quality_control/container/ShowQualityInspect.vue";


import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ae",
  role: "quality_control",
  permission: "container",
});

export default [
  {
    path: "/ae/:agro_exporter_id/quality_control/container/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/ae/:agro_exporter_id/quality_control/container/new_inspection/:agro_exporter_process_id/:container_id/:exporter_process_quality_template_id/:quality_template_id",
    name: routeName("new_inspection"),
    component: NewInspection,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_control/container/edit_inspection/:agro_exporter_process_id/:container_id/:exporter_process_quality_template_id/:quality_template_id/:quality_inspect_id",
    name: routeName("edit_inspection"),
    component: EditInspection,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_control/container/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_control/container/list_containers/:agro_exporter_process_id",
    name: routeName("list_containers"),
    component: ListContainers,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_control/container/list_templates/:agro_exporter_process_id/:container_id",
    name: routeName("list_templates"),
    component: ListTemplates,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_control/container/containers_inspect_graphs/:agro_exporter_process_id/exporter_process_quality_template/:exporter_process_quality_template_id",
    name: routeName("containers_inspect_graphs"),
    component: ContainersInspectGraphs,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_control/container/list_quality_inspects/:agro_exporter_process_id/:container_id/:exporter_process_quality_template_id",
    name: routeName("list_quality_inspects"),
    component: ListQualityInspects,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_control/container/show_quality_inspect/:agro_exporter_process_id/:container_id/:exporter_process_quality_template_id/:quality_inspect_id",
    name: routeName("show_quality_inspect"),
    component: ShowQualityInspect,
    props: true,
    meta: META
  }
];
